import React from 'react';

import { v4 as uuidv4 } from 'uuid';

import Menu from './parts/Menu';
import HeaderMoluna from './parts/HeaderMoluna';

import { PageMode } from './parts/Definitions';

import {
  reactUrlToBrowserUrl,
  reactUrlToTransactionName,
} from '../../../../urlParse';

import './index.scss';
import Loading from './parts/Loading';
import BreadCrumb from './parts/BreadCrumb';
import FooterMoluna from './parts/FooterMoluna';
import {
  getVersion,
  injectPhpDebug,
  replaceAllComplex,
  umcodeURL,
} from '../../../../mol_function';
// import { pushError } from '../../../../pushError';
import {
  basePageHeaderGetterOverrides,
  basePagePostBodyInjectionOverrides,
  childDidReMountAsyncOverrides,
  pageMasterTitle,
} from './overrides';
import CookieManager, {
  ConsentEnum,
  CustommerTypeCookieName,
  getCookie,
  hasConsent,
  setCookie,
} from './parts/CookieManager';

import imgStern from './parts/images/icon-kundenservice.svg';

import $ from 'jquery';

import * as Sentry from '@sentry/react';

interface BasePageProps {
  domainPrefix: string;
  searchSuggestParamInjection: string;
  articleCount: number;
  articlePreis: string;
  isLogin: boolean;
  securityToken: string;
  urlParams: string;
}

export interface BasePageState {
  mode: PageMode;
  hasApiData: boolean;
  apiData: any;
  queryParams: any;
  renderingDomain: string;
  apiBase: string;
  oneCommand?: string;
  isBuchhandler: boolean;
  hasCookie: boolean;
}

export default abstract class Basepage<
  TState extends BasePageState,
  TModel,
> extends React.Component<BasePageProps, TState> {
  checkModeIntervalHandle: NodeJS.Timer;
  apiDataCoruptRestart: NodeJS.Timeout;
  i18Dictinary: any;

  abstract renderChild(): JSX.Element;
  abstract initState(base: BasePageState): TState;
  abstract getApiReqestUrl(checkOnly: boolean): string;
  abstract releaseOneCommand(): void;

  abstract childDidMount(): void;
  abstract childDidUnmount(): void;

  abstract initJSChild(): string;

  abstract childDidUpdate(prevProp: any, prevState: any): void;
  abstract getRightBreadCrumbParts(): JSX.Element;

  abstract pageHeaderGetter(): string | null;
  abstract pageTitleGetter(): string;

  abstract getBreadCrumb(): JSX.Element;

  abstract getType(): string;

  mainContainer: React.Ref<HTMLDivElement>;
  body: TModel;

  constructor(props: any) {
    super(props);

    this.mainContainer = React.createRef();

    let hasApiData = props.apiData != null;
    let apiData = props.apiData;
    let apiUrl = props.apiUrl;
    let renderingDomain = props.renderingUrl;

    let anyProp: any = this.props;

    if (anyProp.mode == 'hot') {
      let localBackup = localStorage.getItem('apidata');
      if (localBackup != null) {
        apiData = JSON.parse(localBackup);
        apiUrl = apiData.domainPrefix;
      }
    }

    if (apiData != null) this.body = apiData.body;

    //TODO: initMode
    let initMode = PageMode.Desktop;
    let mode = props.initResolution;

    if (mode == 'Mobile') initMode = PageMode.Mobile;
    else if (mode == 'Tablet') initMode = PageMode.Tablet;

    let buchHandler = false;

    let cookie = '';

    if (anyProp.mode == 'ssr') {
      let staticContexHandler: any = anyProp.staticContext;
      cookie = staticContexHandler.getCookie(CustommerTypeCookieName);
    } else {
      cookie = getCookie(CustommerTypeCookieName);
    }
    buchHandler = cookie == '2';

    let initState = this.initState({
      mode: initMode,
      hasApiData: hasApiData,
      apiData: apiData,
      queryParams: this.parseQueryParams(),
      renderingDomain: renderingDomain,
      apiBase: apiUrl,
      isBuchhandler: buchHandler,
      hasCookie: cookie != '',
    });

    this.state = initState;

    if (props.postRenderControl != null) {
      props.postRenderControl.headerInjection = this.basePageHeaderGetter();
      props.postRenderControl.title = this.getTitle();
      props.postRenderControl.postBodyInjection =
        basePagePostBodyInjectionOverrides();
    }

    if (this['init_i18n'] != undefined) {
      this.i18Dictinary = this['init_i18n']();
    }
  }

  i18n(key: string): string {
    let currentLang = 'de';

    currentLang = 'dev';

    if (currentLang == 'dev') return key;

    if (this.i18Dictinary[currentLang] != undefined) {
      if (this.i18Dictinary[currentLang][key] != undefined)
        return this.i18Dictinary[currentLang][key];
    }
    debugger;

    return '';
  }

  basePageHeaderGetter() {
    let baseHeader = basePageHeaderGetterOverrides();
    let headerGetter = this.pageHeaderGetter();

    if (headerGetter != null && headerGetter != '')
      return baseHeader + headerGetter;
    else return baseHeader;
  }

  getTitle() {
    let masterTitel = pageMasterTitle();
    let subPageTitle = this.pageTitleGetter();
    if (subPageTitle != '') return subPageTitle + ' - ' + masterTitel;
    else return masterTitel;
  }

  parseQueryParams() {
    let queryParams: any = {};

    let dummyProps: any = this.props;
    let location = dummyProps.location;

    let searchPart = location.search;
    if (searchPart != null) {
      searchPart = searchPart.substring(1);
      let parts = searchPart.split('&');
      for (let i = 0; i < parts.length; i++) {
        let part = parts[i].trim();
        if (part != '') {
          let ptemp = part.split('=');
          queryParams[ptemp[0]] = decodeURI(ptemp[1]);
        }
      }
    }

    return queryParams;
  }

  componentDidUpdate(prevProp: any, prevState: any) {
    let dcp: any = this.props;
    let dPPl = prevProp.location;
    let dCPl = dcp.location;
    let dpl = dPPl.pathname + dPPl.search;
    let dcl = dCPl.pathname + dCPl.search;

    if (dpl != dcl) {
      if (this.apiDataCoruptRestart != undefined) {
        clearTimeout(this.apiDataCoruptRestart);
        this.apiDataCoruptRestart = undefined;
      }
      this.setState({
        apiData: null,
        hasApiData: false,
        queryParams: this.parseQueryParams(),
      });
      this.fetchApiData();
    }
    this.childDidUpdate(prevProp, prevState);
  }

  componentDidMount() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;

    s.innerHTML = this.getAsyncInitJS();
    document.getElementById('main-container')?.append(s);
    this.checkMode();
    //todo Remove on umount
    this.checkModeIntervalHandle = setInterval(() => {
      this.checkMode();
    }, 1000);
    this.childDidReMount();

    window.currentPage = this;

    if (!this.state.hasApiData) {
      this.fetchApiData();
    }
  }

  getAsyncInitJS() {
    return (
      ` function initJSBudle(){
        const s2 = document.createElement('script');
        s2.type = 'text/javascript';
        s2.async = true;
        s2.innerHTML = \`` +
      this.getInitJSInject() +
      `\` ;
        document.getElementById('main-container')?.append(s2);   
      }
      
      function checkReady(){
        
        if(typeof jQuery !==undefined && typeof $ !==undefined ){
          initJSBudle();
        }
        else{
          setTimeout(checkReady,100);
        }
      }
      checkReady();
    
    `
    );
  }

  getInitJSInject() {
    return this.getSearchInitJS() + this.initJSChild();
  }

  getSearchInitJS() {
    /*
    return `
    $("#autosearch").autocomplete({
      source: function( request, response ) {
          $.ajax({
          url: "https://www.moluna.de/searchsuggest/",
          data: { 
      q: ''+request.term+'*',
              fl: "Titel",
              wt: 'json',
           }, 
           dataType: "jsonp",
           jsonp: 'json.wrf',

           success: function( data ) {
              response($.map(data.response.docs, function( item ) { 
                  return { 
                      label: item.Titel,
                      value: item.Titel,
                  }; 
          }));
          }
        }); 
       },
      minLength: 1
      });`;
      */
    return '';
  }

  fetchApiData() {
    let apiUrl = injectPhpDebug(this.getApiReqestUrl(false));

    if (window.historyHelper.request != null) {
      return;
    }

    let traceID = window.historyHelper.traceID;
    if (traceID == undefined) {
      traceID = uuidv4();
      window.historyHelper.traceID = traceID;
    }

    let traceIDRAW =
      traceID.substr(0, 8) +
      traceID.substr(9, 4) +
      traceID.substr(14, 4) +
      traceID.substr(19, 4) +
      traceID.substr(24, 12);

    /*
    Sentry.configureScope((scope) => {
      scope.setTag('transaction_id', traceIDRAW);
    });
    */

    let headers = {
      'Content-Type': 'application/json',
      X_TRACE_ID: traceID,
    };

    let hasCookie = window.historyHelper?.cookieBaner?.hasCookie() == true;

    let reqestPromise = fetch(apiUrl, {
      headers: headers,
      credentials: 'include',
    });

    window.historyHelper.request = reqestPromise;

    reqestPromise
      .then((response) => {
        if (!response.redirected) {
          return response.json();
        } else {
          debugger;
        }

        return response.json();
      })
      .then((data) => {
        window.historyHelper.request = null;

        if (data.REDIRECT == undefined) {
          if (data.isLogin) {
            if (this.state.isBuchhandler != data.userBuchhandler) {
              if (data.userBuchhandler) {
                setCookie(CustommerTypeCookieName, 2, 90, data.cookieDomain);
              } else {
                setCookie(CustommerTypeCookieName, 1, 90, data.cookieDomain);
              }
              window.location.reload();
            }
          }
          this.body = data.body;
          let newState: any = { apiData: data, hasApiData: true };
          if (this.state.oneCommand != null) {
            this.releaseOneCommand();
            newState.oneCommand = null;
          }

          this.setState(newState);
          setTimeout(() => {
            this.childDidReMount();
          }, 500);
        } else {
          window.historyHelper.memory.push(data.REDIRECT, null);
        }
      });
  }

  childDidReMount() {
    setTimeout(() => {
      /*
      let flickis = $('.js-flickity');

      for (let i = 0; i < flickis.length; i++) {
        let config = flickis[i].getAttribute('data-flickity-options');
        if (config != null) {
          try {
            config = JSON.parse(config);
            $(flickis[i]).flickity(config);
          } catch {}
        }
      }
      */
      try {
        childDidReMountAsyncOverrides();
      } catch {}
    }, 100);

    try {
      let anyProps: any = this.props;
      let newUrl = reactUrlToBrowserUrl(
        anyProps.location.pathname,
        anyProps.location.search,
        this.state.apiData,
      );

      if (newUrl != undefined && newUrl != '') {
        let anyWin: any = window;
        let browserHistory = anyWin.historyHelper.browser;
        let oldUrl =
          browserHistory.location.pathname + browserHistory.location.search;

        document.title = this.getTitle();

        let safeUtl = newUrl;
        try {
          decodeURI(safeUtl);
        } catch (error2) {
          safeUtl = umcodeURL(newUrl);
        }

        decodeURI(safeUtl);

        if (hasConsent(ConsentEnum.SENTRY)) {
          /*
          Sentry.configureScope((scope) => {
            let transName = reactUrlToTransactionName(
              anyProps.location.pathname,
            );
            scope.setTransactionName(transName);
          });
          */
        }

        if (newUrl != '' && oldUrl != newUrl) {
          let newUrl2 = newUrl;
          if (!newUrl.includes('%')) {
            newUrl2 = encodeURI(newUrl);
          }
          let oldUrl2 = oldUrl;
          if (!oldUrl.includes('%')) {
            oldUrl2 = encodeURI(oldUrl);
          }

          if (newUrl2 != oldUrl2) {
            browserHistory.push(safeUtl, null);
            window.scrollTo(0, 0);
          }
        }
      }
    } catch (error) {
      try {
        let windowAny: any = window;

        if (
          windowAny.historyHelper != undefined &&
          windowAny.historyHelper.pushError != undefined
        ) {
          windowAny.historyHelper.pushError('BasePage.ReplaceURI', error);
        }
      } catch (error2) {}
    }

    this.childDidMount();
  }

  componentWillUnmount() {
    if (this.checkModeIntervalHandle != undefined)
      clearInterval(this.checkModeIntervalHandle);
    if (this.apiDataCoruptRestart != undefined) {
      clearTimeout(this.apiDataCoruptRestart);
      this.apiDataCoruptRestart = undefined;
    }
    this.childDidUnmount();
  }

  checkMode() {
    let width = 0;
    if (this.mainContainer != null && this.mainContainer != undefined) {
      let dummy: any = this.mainContainer;
      let cur_dummy: any = dummy.current;
      width = cur_dummy.offsetWidth;
    }

    let newMode: PageMode = PageMode.Desktop;
    if (width <= 767) newMode = PageMode.Mobile;
    else if (width <= 1000) newMode = PageMode.Tablet;
    if (this.state.mode != newMode) this.setState({ mode: newMode });
  }

  renderCheckUrlAsync() {
    let hasApiData = this.state.hasApiData;

    if (hasApiData && this.props.mode == 'react') {
      let validUrl = this.getApiReqestUrl(true);

      validUrl = validUrl.substring(this.state.apiBase.length);

      validUrl = validUrl.trim();

      let apiDatataUrl = this.state.apiData.apiRequestUri;

      let notValidCheck = validUrl != apiDatataUrl;

      if (notValidCheck) {
        let de_validUrl = decodeURIComponent(validUrl);
        let de_apiDatataUrl = decodeURIComponent(apiDatataUrl);
        notValidCheck = de_validUrl != de_apiDatataUrl;
      }

      if (notValidCheck && getVersion() == 'develop') {
        debugger;
      }

      if (notValidCheck) {
        //prevent Search loop
        let apiSearchPrefix = '/SearchPage.php';
        if (
          apiDatataUrl != null &&
          apiDatataUrl.startsWith(apiSearchPrefix) &&
          validUrl.startsWith(apiSearchPrefix)
        )
          notValidCheck = false;
      }

      if (notValidCheck) {
        hasApiData = false;
        if (this.apiDataCoruptRestart == undefined) {
          this.apiDataCoruptRestart = setTimeout(() => {
            if (this.state.hasApiData) {
              /*
              console.log({
                validUrl: validUrl,
                apiDatataUrl: apiDatataUrl,
              });
              */
              this.setState({ hasApiData: false, apiData: null });
              this.fetchApiData();
            }
            this.apiDataCoruptRestart = undefined;
          }, 1000);
        }
      }
    }

    return hasApiData;
  }

  render() {
    let hasApiData = this.renderCheckUrlAsync();

    let childPart = hasApiData ? this.renderChild() : <Loading />;

    let showPartner = this.getType() != 'ShoppingCartPage';
    let showSearch = true;

    let stateInfo = {
      articleCount: undefined,
      isLogin: undefined,
      articlePreis: undefined,
    };

    if (hasApiData) {
      stateInfo = this.state.apiData;
    }

    let showBreadCrumb = true;

    if (this.state.mode == PageMode.Mobile) showBreadCrumb = false;

    if (
      showBreadCrumb &&
      (this.getType() == 'SearchPage' || this.getType() == 'StartPage')
    )
      showBreadCrumb = false;

    let footerLinks = [];
    if (this.state?.apiData?.footerLinks != null) {
      footerLinks = this.state.apiData.footerLinks;
    }

    let cookieDomain = '';
    if (this.state.hasApiData) cookieDomain = this.state.apiData.cookieDomain;

    return (
      <>
        <div id="mobileMenuContainer">
          {/* 
          <Menu domainPrefix={this.state.renderingDomain} isMobil={true} />
        */}
        </div>
        <div id="main-container" ref={this.mainContainer}>
          <div id="headerSection">
            <HeaderMoluna
              domainPrefix={this.state.renderingDomain}
              articleCount={stateInfo.articleCount}
              articlePreis={stateInfo.articlePreis}
              isLogin={stateInfo.isLogin}
              showSearch={showSearch}
              subTitel={
                this.state.hasCookie ? (
                  <li className="subTitel">
                    {this.state.isBuchhandler
                      ? 'Barsortiment on demand für Buchhändler'
                      : 'Großhändler on demand für Firmenkunden'}{' '}
                    {stateInfo.isLogin ? null : (
                      <img
                        src={imgStern}
                        style={{
                          cursor: 'pointer',
                          width: '20px',
                        }}
                        onClick={() => {
                          window.historyHelper.cookieBaner.showBanner();
                        }}
                      ></img>
                    )}
                  </li>
                ) : null
              }
            ></HeaderMoluna>
            {/* 
            <Menu domainPrefix={this.state.renderingDomain} isMobil={false} />
            */}
            {showBreadCrumb ? (
              <BreadCrumb
                domainPrefix={this.state.renderingDomain}
                rightItem={this.getRightBreadCrumbParts()}
              >
                {this.getBreadCrumb()}
              </BreadCrumb>
            ) : null}
          </div>
        </div>
        <div id="bodySection">{childPart}</div>
        <br className="clearBoth" />

        <div id="footerSection">
          <FooterMoluna
            domainPrefix={this.state.renderingDomain}
            showPartnerDiv={showPartner}
            footerLinks={footerLinks}
          />
        </div>
        <div
          id="trustbadgeCustomContainer"
          style={{ position: 'fixed', bottom: '100px' }}
        ></div>
        <CookieManager cookieDomain={cookieDomain} />
      </>
    );
  }
}

export function startPopup() {
  window.document.body.classList.add('noScroll');
  $('#cmpboxrecall').hide();
  $('div').filter((index: number, element: HTMLElement) => {
    if (!element.id.startsWith('trustbadge-container')) return false;
    $(element).hide();
    return true;
  });
}

export function endPopup() {
  window.document.body.classList.remove('noScroll');

  $('#cmpboxrecall').show();
}
